'use strict';

require('core-js/modules/es6.array.find');

require('core-js/modules/es6.array.is-array');

require('core-js/modules/es6.array.for-each');

require('core-js/modules/es6.string.starts-with');

require('core-js/modules/es6.map');

require('core-js/modules/es6.promise');

require('linksoft-albatros/src/plugins/dropdown');

require('linksoft-albatros/src/plugins/jquery.sticky-fit');

require('linksoft-albatros/src/plugins/jquery-throttle-debounce');

var _urls = require('./app/urls');

var _initializersFirst = require('./app/initializers-first');

var _initializersFirst2 = _interopRequireDefault(_initializersFirst);

var _store = require('./app/store');

var _store2 = _interopRequireDefault(_store);

var _store3 = require('linksoft/core/store');

var _store4 = _interopRequireDefault(_store3);

var _settingsFix = require('./app/settingsFix');

var _settingsFix2 = _interopRequireDefault(_settingsFix);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _initialize = require('linksoft/core/initialize');

var _initialize2 = _interopRequireDefault(_initialize);

var _localize = require('linksoft/core/localize');

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

require('./app/components');

var _reducers = require('linksoft/core/reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _reducer = require('./app/cart/reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = require('./app/customer/reducer');

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = require('./app/facets/reducer');

var _reducer6 = _interopRequireDefault(_reducer5);

var _reduxForm = require('redux-form');

var _linksoftReact = require('linksoft-react');

var _linksoftReact2 = _interopRequireDefault(_linksoftReact);

require('linksoft/initializers/cookie-value');

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This is entry point for building single output 'main.js' (except vendor libs defined in 'Gulp/vendors.js')

// polyfills
var log = (0, _debug2.default)('app:startup');

// Load all React.js components/containers

// register reducers before creating store


_reducers2.default.add('cart', _reducer2.default);
_reducers2.default.add('customer', _reducer4.default);
_reducers2.default.add('facets', _reducer6.default);
_reducers2.default.add('forms', _reduxForm.reducer);

// register all required initializers
_initialize2.default.registerAll(_initializersFirst2.default);

_initialize2.default.register(_linksoftReact2.default.finalizer, true);

(0, _jquery2.default)(document).on('loaded.bs.modal', function (e) {
    log('modal content loaded %o', e.target);
    _initialize2.default.trigger(e.target);
});

// detect IE11 and lower
if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
    (0, _jquery2.default)('html').addClass('ie11');
}

// trigger first initialization.
(0, _jquery2.default)(function () {
    // create app state store
    _store4.default.set((0, _store2.default)());

    _settingsFix2.default.backupSettings();
    _linksoftAlbatros.settings.initFromHiddenField('settings');
    _settingsFix2.default.restoreSettingsElement();

    (0, _localize.loadLocale)().then(function () {
        (0, _urls.initUrls)();
        _initialize2.default.trigger();
    });

    if (window.location.hash === "#Login") {
        window.location.replace('#');
        (0, _jquery2.default)('#loginBox').modal('show');
    }

    (0, _jquery2.default)(document).on('click', '#btn-contact-form', function (e) {
        e.preventDefault();
        var url = (0, _jquery2.default)(this).attr('href');
        var $content = (0, _jquery2.default)('#contact-form .modal-content');

        if ($content.is(':empty')) {
            _jquery2.default.ajax(url).done(function (result) {
                $content.html(result);

                (0, _jquery2.default)('#contact-form').modal('show');
                _initialize2.default.trigger();
            });
        } else {
            (0, _jquery2.default)('#contact-form').modal('show');
        }
    });
});

// catlist FF fix

var $catBox = (0, _jquery2.default)('.category__main');
if ($catBox.length > 0 && !(0, _linksoftAlbatros.isMaxWidth)('md')) {
    (0, _linksoftAlbatros.addResizeListener)($catBox[0], function () {
        var listHeight = $catBox.outerHeight();

        if (document.querySelector('.cat-nav') !== null) {
            var catBoxHeight = document.querySelector('.cat-nav').clientHeight;

            (0, _jquery2.default)('.facets__wrap-inner', document).css('height', listHeight - catBoxHeight);
        } else {
            (0, _jquery2.default)('.facets__wrap-inner', document).css('height', listHeight);
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./Scripts/base.js
// module id = 0
// module chunks = 0